module.exports = __webpack_public_path__ + "static/media/pdbVietKitchenMobile.2cb635bd.svg";